export function getTFGPlayerTableColumns({
  showActions = true,
  showNew = true,
  showIsRemoved = true,
}) {
  let cols = [
    {
      id: "_id",
      label: `Update Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "playerId",
      label: `Player Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "displayName",
      label: `Display Name`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "commonNameForename",
      label: `First name`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "commonNameSurname",
      label: `Surname`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "league",
      label: `League`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "club",
      label: `Club`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "preferredPosition",
      label: `Primary Pos`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "secondaryPosition1",
      label: `2nd pos`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "secondaryPosition2",
      label: `3rd pos`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "nationality",
      label: `Nationality`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "attackRating",
      label: `ATT. Rating`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "defenseRating",
      label: `DEF. Rating`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "creativityRating",
      label: `CRT. Rating`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "overallRating",
      label: `OVRL. Rating`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "shirtNumber",
      label: `Shirt No.`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
  ];
  if (showNew)
    cols.push({
      id: "isNewRec",
      label: `Is New`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    });
  if (showIsRemoved)
    cols.push({
      id: "isRemoved",
      label: `Is Removed`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    });
  if (showActions)
    cols.push({
      id: "actions",
      label: `Actions`,
    } as any);
  return cols;
}
